import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class UtentiService {

    static getAllUtenti = () => {
        let url = `${REACT_APP_REST_ENDPOINT}/utenti`;
        return ApiService.getRudeRequest(url);
      };

      static getUtenteByParams = (params) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/find`;
            ApiService.postRudeRequest(resolve, reject, url, params)
        });
      };  


      static createUtente = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/admin/utenti/create`;
            ApiService.postRequest(resolve, reject, url, data)
        });
     }

     static deleteUtente = (data) => {
      return new Promise((resolve, reject) => {
          const url = `${REACT_APP_REST_ENDPOINT}/admin/utenti/delete`;
          ApiService.delete(resolve, reject, url, data)
      });
   }
     static enableUtente = (data) => {
      return new Promise((resolve, reject) => {
          const url = `${REACT_APP_REST_ENDPOINT}/admin/utenti/enable`;
          ApiService.postRequest(resolve, reject, url, data)
      });
    }
     static disableUtente = (data) => {
      return new Promise((resolve, reject) => {
          const url = `${REACT_APP_REST_ENDPOINT}/admin/utenti/disable`;
          ApiService.postRequest(resolve, reject, url, data)
      });
    }

    static findByRole = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/findByTipo`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static resendEmail = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/reinoltroEmail`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static resendEmailNoAuth = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/reinviaEmailRegistrazione`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }


    static findByIdAgenzia = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/findByAgenzia`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static inviteFriend = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/inviteFriend`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static updateUtente = (data, isFormData = false) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/utenti/update`;
            ApiService.postRequest(resolve, reject, url, data, isFormData);
        });
    };
    // static updateUtente = (data) => {
    //     return new Promise((resolve, reject) => {
    //         const url = `${REACT_APP_REST_ENDPOINT}/utenti/update`;
    //         ApiService.postRequest(resolve, reject, url, data)
    //     });
    // }

   


}